<div class="appointment-details">
  <div class="detail-id">
    <span class="material-symbols-outlined">event</span>
    <strong>ID Do Agendamento:</strong>
    <span>{{ appointment.id }}</span>
  </div>

  <div class="detail-section">
    <div class="detail-section-title">
      <span class="material-symbols-outlined">calendar_month</span>
      Agendamento
    </div>
    <div class="detail-row">
      <div class="detail-item">
        <span class="material-symbols-outlined">calendar_today</span>
        <strong>Agenda:</strong> {{ scheduleName }}
      </div>
      <div class="detail-item">
        <span class="material-symbols-outlined">oncology</span>
        <strong>Exame:</strong> {{ procedureNames }}
      </div>
      <div class="detail-item">
        <span class="material-symbols-outlined">calendar_today</span>
        <strong>Data:</strong> {{ appointment.start | date:'dd/MM/yyyy' }}
      </div>
    </div>
    <div class="detail-row">
      <div class="detail-item">
        <span class="material-symbols-outlined">schedule</span>
        <strong>Horario:</strong> {{ appointment.start | date:'HH:mm' }}
      </div>
      <div class="detail-item">
        <span class="material-symbols-outlined">play_arrow</span>
        <strong>Status:</strong> {{ statusLabel }}
      </div>
    </div>
    @if (appointment.observation) {
      <div class="detail-row">
        <div class="detail-item">
          <span class="material-symbols-outlined">notes</span>
          <strong>Observação:</strong> {{ appointment.observation }}
        </div>
      </div>
    }
  </div>

  <hr class="detail-divider" />

  <div class="detail-section">
    <div class="detail-section-title">
      <span class="material-symbols-outlined">person</span>
      Paciente
    </div>
    <div class="detail-row">
      <div class="detail-item detail-item--highlight">
        <strong>Nome:</strong> {{ appointment.patient?.name }}
      </div>
      @if (appointment.patient?.birthDate) {
        <div class="detail-item">
          <span class="material-symbols-outlined">calendar_today</span>
          <strong>Data de Nascimento:</strong> {{ appointment.patient?.birthDate }}
        </div>
      }
    </div>
    <div class="detail-row">
      @if (appointment.insurance) {
        <div class="detail-item">
          <span class="material-symbols-outlined">credit_card</span>
          <strong>Convenio:</strong> {{ appointment.insurance?.name }}
        </div>
      }
      @if (appointment.patient?.phone) {
        <div class="detail-item">
          <span class="material-symbols-outlined">call</span>
          <strong>Telefone:</strong> {{ appointment.patient?.phone }}
        </div>
      }
    </div>
  </div>

  <hr class="detail-divider" />

  <div class="detail-section">
    <div class="detail-section-title">
      <span class="material-symbols-outlined">stethoscope</span>
      Profissionais
    </div>
    <div class="detail-row">
      @if (appointment.performingDoctor) {
        <div class="detail-item">
          <span class="material-symbols-outlined">stethoscope</span>
          <strong>Medico Executante:</strong> {{ appointment.performingDoctor?.name }}
        </div>
      }
    </div>
    <div class="detail-row">
      @if (appointment.requestingDoctor) {
        <div class="detail-item">
          <span class="material-symbols-outlined">stethoscope</span>
          <strong>Medico Solicitante:</strong> {{ appointment.requestingDoctor?.name }}
        </div>
      }
    </div>
  </div>

  <div class="detail-actions">
    <button class="btn-history" type="button" (click)="onHistory()">
      <span class="material-symbols-outlined">history</span>
      Histórico
    </button>
    <button class="btn-open-appointment" type="button" (click)="onOpenAppointment()">
      @if (isLockedByOther) {
        Destrancar horário e ir para o agendamento
      } @else {
        Abrir Agendamento
      }
    </button>
  </div>
</div>
